import Vue from 'vue'
import * as types from '../mutation-types'

export default {
	[types.CLEAR_PAGE_HISTORY]: (state) => {
		Vue.set(state, 'pageHistory', []);
	},
	[types.SET_CURRENT_PAGE_INDEX]: (state, currentPageIndex) => {
		Vue.set(state, 'currentPageIndex', currentPageIndex)

		let pageHistory = state.pageHistory || [];

		pageHistory.push(currentPageIndex);

		Vue.set(state, 'pageHistory', pageHistory);

		console.log('New page history: ', pageHistory, state);
	},

	[types.SET_CURRENT_PAGE_PHASE]: (state, currentPagePhase) => {
		Vue.set(state, 'currentPagePhase', currentPagePhase)
	}
}